const prefix = 'STAKEHOLDER_MERGE';

export default {
  MERGE_STAKEHOLDERS: `${prefix}/MERGE_STAKEHOLDERS`,
  MERGE_STAKEHOLDERS_FAIL: `${prefix}/MERGE_STAKEHOLDERS_FAIL`,
  MERGE_STAKEHOLDERS_DONE: `${prefix}/MERGE_STAKEHOLDERS_DONE`,
};
